// @flow
import React, { type Element } from 'react';
import { Box } from 'gestalt';

const GRID_COLUMNS = 3;
const GRID_ROWS = 10;
const GRID_COLORS = [
  'blue',
  'eggplant',
  'green',
  'maroon',
  'midnight',
  'navy',
  'olive',
  'orange',
  'orchid',
  'pine',
  'purple',
  'watermelon',
];

function NuxEducationLoaderGrid() {
  function buildGrid(): Array<Array<Element<any>>> {
    const gridOfBoxes = [];
    let colorIndex = 0;
    for (let row = 0; row < GRID_ROWS; row += 1) {
      gridOfBoxes.push([]);
      for (let col = 0; col < GRID_COLUMNS; col += 1) {
        const color = GRID_COLORS[colorIndex];
        gridOfBoxes[row].push(
          <div key={row + col} className={`NuxEducationLoaderGrid__column${col}`}>
            <Box
              color={color}
              height={155}
              width={105}
              dangerouslySetInlineStyle={{ __style: { borderRadius: 8 } }}
            />
          </div>,
        );
        colorIndex += 1;
        if (colorIndex >= GRID_COLORS.length) {
          colorIndex = 0;
        }
      }
    }
    return gridOfBoxes;
  }

  const gridOfBoxes = buildGrid();
  return <div className="NuxEducationLoaderGrid">{gridOfBoxes}</div>;
}

// $FlowIssue Currently installed version of Flow doesn't understand React.memo
export default React.memo(NuxEducationLoaderGrid);
